<script setup>
defineProps({
    width: {
        default: 18
    }
})
</script>

<template>
    <img class="loading-spinner" src="/storage/images/loading.png" alt="Загрузка..." :style="`width: ${width}px;`"/>
</template>

<style scoped>
@keyframes spin {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}

.loading-spinner {
    animation: spin infinite 0.5s linear;
}
</style>